<template>
  <div class="app">
    <DefaultHeader/>
    <div class="app-body">
      <AppSidebar fixed>
        <SidebarHeader/>
        <SidebarForm/>
        <SidebarNav :navItems="nav"></SidebarNav>
        <SidebarFooter/>
        <SidebarMinimizer/>
      </AppSidebar>
      <main class="main">
        <Breadcrumb :list="list"/>
        <div class="container-fluid">
          <div class="dashboard-list" v-show="this.$route.name=='Admin Dashboard'">
            
            <div class="mt-3">
              <b-card-group deck>
                <b-card bg-variant="info" text-variant="white" header="Campaign" class="text-center">                  
                  <b-card-text>Campaign List.</b-card-text>
                  <router-link :to="{name: 'Campaign'}"  class="btn btn-dark btn-sm" ><i class="fa fa-bullhorn"></i></router-link>
                </b-card>

                <b-card bg-variant="info" text-variant="white" header="Marketing Event" class="text-center">
                  <b-card-text>Marketing Event List.</b-card-text>
                  <router-link :to="{name: 'Event Manager'}" class="btn btn-dark btn-sm" ><i class="fa fa-calendar"></i></router-link>      
                </b-card>

                <b-card bg-variant="info" text-variant="white" header="Contact Manager" class="text-center">
                  <b-card-text>Contact List.</b-card-text>
                  <router-link :to="{name: 'Contact Manager'}"  class="btn btn-dark btn-sm" ><i class="fa fa-address-book"></i></router-link>      
                </b-card>
              </b-card-group>
            </div>
            <div class="mt-3">
              <b-card-group deck>
                <b-card bg-variant="info" text-variant="white" header="Users" class="text-center">                  
                  <b-card-text>User List.</b-card-text>
                  <router-link :to="{name: 'Users'}"  class="btn btn-dark btn-sm" ><i class="fa fa-users"></i></router-link>      
                </b-card>

                <b-card bg-variant="info" text-variant="white" header="Roles" class="text-center">
                  <b-card-text>Roles List.</b-card-text>
                  <router-link :to="{name: 'Roles'}"  class="btn btn-dark btn-sm" ><i class="fa fa-user-secret"></i></router-link>      
                </b-card>

                <b-card bg-variant="info" text-variant="white" header="Duplicate Contact" class="text-center">
                  <b-card-text>Duplicate Contact List.</b-card-text>
                  <router-link :to="{name: 'Duplicate Contact'}"  class="btn btn-dark btn-sm" ><i class="fa fa-database"></i></router-link>      
                </b-card>
              </b-card-group>
            </div>
            <div class="mt-3">
              <b-card-group deck>
                <b-card bg-variant="info" text-variant="white" header="Import Contact" class="text-center">                  
                  <b-card-text>Import Contact List.</b-card-text>
                  <router-link :to="{name: 'Import Contact List'}"  class="btn btn-dark btn-sm" ><i class="fa fa-upload"></i></router-link>      
                </b-card>

                <b-card bg-variant="info" text-variant="white" header="Direct Mass Import" class="text-center">
                  <b-card-text>Direct Mass Import List.</b-card-text>
                  <router-link :to="{name: 'Direct Mass Import'}"  class="btn btn-dark btn-sm" ><i class="fa fa-upload"></i></router-link>                                        
                </b-card>

                <b-card bg-variant="info" text-variant="white" header="Export Contact" class="text-center">
                  <b-card-text>Export Contact List.</b-card-text>
                  <router-link :to="{name: 'Export Contact'}"  class="btn btn-dark btn-sm" ><i class="fa fa-download"></i></router-link>                                        
                </b-card>
              </b-card-group>              
            </div>
            <div class="mt-3">
            <b-row>
              <b-col cols="4">
                <b-card bg-variant="info" text-variant="white" header="Weightages Setting" class="text-center">                  
                  <b-card-text>Weightages List.</b-card-text>
                  <router-link :to="{name: 'Weightages'}" class="btn btn-dark btn-sm" ><i class="fa fa-calculator"></i></router-link>                                        
                </b-card>
              </b-col>
              <b-col cols="4">
                <b-card bg-variant="info" text-variant="white" header="Contact Trash" class="text-center">
                  <b-card-text>Trashed Contact List.</b-card-text>
                  <router-link :to="{name: 'Trash Contacts'}"  class="btn btn-dark btn-sm" ><i class="fa fa-trash"></i></router-link>                                        
                </b-card>                
              </b-col>
            </b-row>
            </div>
          </div>
          <router-view></router-view>
        </div>
      </main>
      <AppAside fixed>
        <!--aside-->
        <DefaultAside/>
      </AppAside>
    </div>
    <DefaultFooter/>
  </div>
</template>

<script>
import nav from '@/views/admin/_nav'
import { Sidebar as AppSidebar, SidebarFooter, SidebarForm, SidebarHeader, SidebarMinimizer, SidebarNav, Aside as AppAside, Breadcrumb } from '@coreui/vue'
import DefaultAside from './DefaultAside'
import DefaultHeader from './DefaultHeader'
import DefaultFooter from './DefaultFooter'

export default {
  name: 'DefaultContainer',
  components: {
    AppSidebar,
    AppAside,
    Breadcrumb,
    DefaultAside,
    SidebarForm,
    SidebarFooter,
    SidebarHeader,
    SidebarNav,
    SidebarMinimizer,
    DefaultFooter,
    DefaultHeader
  },
  data () {
    return {
      nav: nav.items
    }
  },
  computed: {
    name () {
      return this.$route.name
    },
    list () {
      return this.$route.matched.filter((route) => route.name || route.meta.label )
    }
  }
}
</script>
